import { http } from '../../config/axios'

export default function getTipoIntervaloNotificacao(): Promise<any> {
  return http
    .get('api/notificacao-fatura/tipos-intervalo')
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro getTipoIntervaloNotificacao', error)
      throw Error(error.response.data)
    })
}
